import HiviewerLoader from "../shared/HiviewerLoader";

const DotsLoader = () => {
  return <HiviewerLoader />;
}
export default DotsLoader;
